"use strict";
var $dyn;
(function ($dyn) {
    var ax;
    (function (ax) {
        var taskGuidesUtil;
        (function (taskGuidesUtil) {
            /**
             * Helper for ScrollComponent
             * Wraps the interesting visibility bits necessary for Task Recorder.
             */
            var VisibilityData = /** @class */ (function () {
                /** options Existing visibility data to copy */
                function VisibilityData(options) {
                    this.horizontalVisibility = options.horizontalVisibility;
                    this.verticalVisibility = options.verticalVisibility;
                    this.visibleArea = options.visibleArea;
                    this.elementRect = options.elementRect;
                    this.$element = options.$element;
                }
                VisibilityData.prototype.isVisible = function () {
                    return this.horizontalVisibility === $dyn.util.HorizontalElementVisibility.VISIBLE && this.verticalVisibility === $dyn.util.VerticalElementVisibility.VISIBLE;
                };
                VisibilityData.prototype.isPartiallyVisible = function () {
                    return (this.horizontalVisibility === $dyn.util.HorizontalElementVisibility.PARTIAL || this.horizontalVisibility === $dyn.util.HorizontalElementVisibility.VISIBLE) &&
                        (this.verticalVisibility === $dyn.util.VerticalElementVisibility.PARTIAL || this.verticalVisibility === $dyn.util.VerticalElementVisibility.VISIBLE);
                };
                VisibilityData.prototype.isInvisible = function () {
                    return !this.isVisible() && !this.isPartiallyVisible();
                };
                VisibilityData.prototype.isGloballyVisible = function () {
                    return this.visibleArea && this.isVisible();
                };
                VisibilityData.prototype.isGloballyPartiallyVisible = function () {
                    return this.visibleArea && this.isPartiallyVisible();
                };
                VisibilityData.prototype.horizontalVisibilityLabel = function () {
                    if (this.horizontalVisibility === $dyn.util.HorizontalElementVisibility.PARTIAL) {
                        return $dyn.util.HorizontalElementVisibility.VISIBLE;
                    }
                    return this.horizontalVisibility;
                };
                VisibilityData.prototype.verticalVisibilityLabel = function () {
                    if (this.verticalVisibility === $dyn.util.VerticalElementVisibility.PARTIAL) {
                        return $dyn.util.VerticalElementVisibility.VISIBLE;
                    }
                    return this.verticalVisibility;
                };
                return VisibilityData;
            }());
            taskGuidesUtil.VisibilityData = VisibilityData;
        })(taskGuidesUtil = ax.taskGuidesUtil || (ax.taskGuidesUtil = {}));
    })(ax = $dyn.ax || ($dyn.ax = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=VisibilityData.js.map
